<template>
  <div>
    <h1>Cambiar contraseña</h1>
    <div class="card">
      <div class="card-body">
        <h5 class="mb-4"></h5>
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <a-form-item label="Contraseña actual">
                <a-input
                  :type="!oldPasswordHidden ? 'password':'text'"
                  placeholder="Contraseña actual"
                  v-model="$v.changePassword.oldPassword.$model"
                />
                <span v-if="oldPasswordHidden" class="display-eye fa fa-eye" @click="showOldPasswordHidden"></span>
                <span v-if="!oldPasswordHidden" class="display-eye fa fa-eye-slash" @click="hideOldPasswordHidden"></span><br>
                <small class="text-danger" v-if="!$v.changePassword.oldPassword.required">Campo requerido. No debe estar vacío.</small><br>
                <small class="text-danger" v-if="!$v.changePassword.oldPassword.password">La contraseña no es válida. Vuelve a intentarlo. La contraseña debe tener 8 caracteres como mínimo. Incluye letras mayúsculas, letras minúsculas, números y caracteres especiales.</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Contraseña nueva">
                <a-input
                :type="!newPasswordHidden ? 'password':'text'"
                  placeholder="Contraseña nueva"
                  v-model="$v.changePassword.newPassword.$model"
                />
                <span v-if="newPasswordHidden" class="display-eye fa fa-eye" @click="showNewPasswordHidden"></span>
                <span v-if="!newPasswordHidden" class="display-eye fa fa-eye-slash" @click="hideNewPasswordHidden"></span><br>
                <small class="text-danger" v-if="!$v.changePassword.newPassword.required">Campo requerido. No debe estar vacío.</small><br>
                <small class="text-danger" v-if="!$v.changePassword.newPassword.password">La contraseña no es válida. Vuelve a intentarlo. La contraseña debe tener 8 caracteres como mínimo. Incluye letras mayúsculas, letras minúsculas, números y caracteres especiales.</small>
              </a-form-item>
            </div>
            <div class="col-12">
              <a-form-item>
                <button
                :disabled="$v.$invalid"
                  type="submit"
                  class="btn btn-light px-5"
                >
                  Guardar
                </button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>
<script>
import { required, helpers } from 'vuelidate/lib/validators'
const password = helpers.regex('password', /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}$/)
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      oldPasswordHidden: false,
      newPasswordHidden: false,
      changePassword: {
        oldPassword: null,
        newPassword: null,
      },
    }
  },
  created() {
    this.$cognito.isAuthenticated()
      .then(() => {
        // console.log(result)
      })
      .catch(error => {
        console.log(error)
      })
  },
  methods: {
    handleSubmit() {
      // console.log(this.changePassword.oldPassword, this.changePassword.newPassword)
      this.$cognito.updatePassword(this.changePassword.oldPassword, this.changePassword.newPassword)
        .then(result => {
          this.makeToast(true, 'success', 'Cambio de contraseña correcto', 'La contraseña se ha cambiado correctamente.')
          this.changePassword.oldPassword = null
          this.changePassword.newPassword = null
          console.log(result)
        })
        .catch(error => {
          // console.log(error)
          switch (error.message) {
            case 'Incorrect username or password.':
              this.makeToast(true, 'warning', 'Error', 'No se pudo cambiar la contraseña')
              break
            case 'Attempt limit exceeded, please try after some time.':
              this.makeToast(true, 'warning', 'Error', 'Se superó el límite de intentos para cambiar tu contraseña.Intenta más tarde.')
              break
            default:
              this.makeToast(true, 'warning', 'Error', 'No se pudo cambiar la contraseña.')
              break
          }
          // console.log(error)
        })
    },
    showOldPasswordHidden() {
      this.oldPasswordHidden = false
    },
    hideOldPasswordHidden() {
      this.oldPasswordHidden = true
    },
    showNewPasswordHidden() {
      this.newPasswordHidden = false
    },
    hideNewPasswordHidden() {
      this.newPasswordHidden = true
    },
    makeToast(append = false, variant, title, message) {
      this.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 5000,
        appendToast: append,
        variant: variant,
      })
    },
  },
  validations: {
    changePassword: {
      oldPassword: { required, password },
      newPassword: { required, password },
    },
  },
}
</script>
<style>
.space {
  height: 10px;
}
.display-eye {
  cursor:pointer;
}
</style>
